import React from 'react';

const Raw = (props) => {
  return <React.Fragment>
    <h2>{props.name} is Not Defined</h2>
    <pre>{JSON.stringify(Object.keys(props))}</pre>;
  </React.Fragment>
}

export default Raw;